import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { getNotificationTypes } from '../../services/notificationsService';
import { notificationTypesState } from '../../storage/notifications';

export default function NotificationsProvider() {
  const setNotificationTypes = useSetRecoilState(notificationTypesState);

  useEffect(() => {
    const loadNotificationTypes = async () => {
      const { notificationTypes, error } = await getNotificationTypes();

      if (!error && notificationTypes) {
        setNotificationTypes(notificationTypes);
      }
    };
    loadNotificationTypes();
  }, []);

  return null;
}
